import { DateRange } from 'react-day-picker'

export const validateIsFullDateFilled = (value: DateRange | undefined): Promise<string> => {
  const result = !!(value && value['from'] && value['to'])

  return Promise.resolve(result ? '' : 'You must fill in the start and end dates of the period')
}
